import { render, staticRenderFns } from "./works_list.vue?vue&type=template&id=6ecb5de6&lang=pug&"
import script from "./works_list.vue?vue&type=script&setup=true&lang=js&"
export * from "./works_list.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./works_list.vue?vue&type=style&index=0&id=6ecb5de6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports